import { render } from "./InsureTemplateForm.vue?vue&type=template&id=ab95cdf2"
import script from "./InsureTemplateForm.vue?vue&type=script&lang=js"
export * from "./InsureTemplateForm.vue?vue&type=script&lang=js"

import "./InsureTemplateForm.vue?vue&type=style&index=0&id=ab95cdf2&lang=less"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__